import { useDispatch, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { toggleDesignSystemFilterCategory, clearDesignSystemFilters } from 'redux/mode/actions';
import { TokenCategory, PrimitiveCategory, ComponentCategory } from 'designSystem/types';
import * as S from './FilterPills/styles';

interface FilterPillsProps {
	section: 'tokens' | 'styles' | 'components';
	categories: Array<{
		value: TokenCategory | PrimitiveCategory | ComponentCategory;
		label: string;
		count: number;
	}>;
}

const FilterPills = ({ section, categories }: FilterPillsProps) => {
	const dispatch = useDispatch();
	const selectedCategories = useSelector(
		(r: RootReducer) => r.mode.designSystemFilters[section].selectedCategories
	);

	const handleToggle = (category: TokenCategory | PrimitiveCategory | ComponentCategory) => {
		dispatch(toggleDesignSystemFilterCategory({ section, category }));
	};

	const handleClearAll = () => {
		dispatch(clearDesignSystemFilters(section));
	};

	if (categories.length === 0) {
		return null;
	}

	const hasSelectedFilters = selectedCategories.length > 0;

	return (
		<S.Container>
			{/* Category pills */}
			{categories.map((category) => {
				const isSelected = (selectedCategories as any[]).includes(category.value);
				return (
					<S.Pill
						key={category.value}
						selected={isSelected}
						onClick={() => handleToggle(category.value)}
					>
						{category.label}
						{category.count !== undefined && <S.Count>({category.count})</S.Count>}
					</S.Pill>
				);
			})}
			{/* Clear button - clings to pills with non-breaking space */}
			{hasSelectedFilters && <S.ClearButton onClick={handleClearAll}>Clear</S.ClearButton>}
		</S.Container>
	);
};

export default FilterPills;
